import React from "react";
import PropTypes from "prop-types";

import Button from "../Button/Button";

const LinkListItem = ({ text, to, onClick, icon, iconPosition, className, ...props }) => (
  <li className={className} {...props}>
    <Button
      textAlignment="left"
      text={text}
      variant="link"
      to={to}
      onClick={onClick}
      icon={icon}
      iconPosition={iconPosition}
    />
  </li>
);

LinkListItem.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.func,
  iconPosition: PropTypes.string,
};

export default LinkListItem;
